module.exports = __webpack_public_path__ + "static/media/ambassador-overview.5954710a.jpg";